/**
 * Wind loading per TIA-222 (see docs/ENGINEERING.md §1). Velocity pressure
 * q = 0.613·Kz·V² (Pa, V in m/s); Kz scales pressure up with height, which is
 * why top-mounted loads are so punishing.
 */

const ZG = 274; // gradient height for Exposure C (m)
const ALPHA = 9.5; // Exposure C

/** Height/exposure coefficient Kz for Exposure C (open terrain). */
export function Kz(z: number): number {
  return Math.max(0.85, 2.01 * Math.pow(Math.max(z, 0) / ZG, 2 / ALPHA));
}

/** Velocity pressure at height z (Pa) for wind speed V (m/s, 3-s gust). */
export function velocityPressure(V: number, z: number): number {
  return 0.613 * Kz(z) * V * V;
}
